<template>
  <div id="modals">
    <template v-for="(modal, modalId) in modals" :key="modalId">
      <transition name="modal">
        <component 
          :is="modalId"
          v-bind="modal"
          v-if="modal.modelValue"
          @update:modelValue="modal.modelValue = $event"
          @close="modal.modelValue = false">
        </component>
      </transition>
    </template>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { store } from '@/store'

import GiveFeedback from '@/components/modals/GiveFeedback.vue'
import PrivacyConsent from '@/components/modals/PrivacyConsent.vue'
import CreateRoute from '@/components/modals/CreateRoute.vue'
import PlaceSettings from '@/components/route/PlaceSettings.vue'
import RouteSettings from '@/components/modals/RouteSettings.vue'
import PlaceImporter from '@/components/modals/PlaceImporter.vue'
import ShareRoute from '@/components/modals/ShareRoute.vue'
import AssignDriver from '@/components/modals/AssignDriver.vue'
import Message from '@/components/modals/Message.vue'
import SignIn from '@/components/modals/SignIn.vue'
import PayWall from '@/components/modals/PayWall.vue'

export default defineComponent({
  name: 'AppModals',
  components: {
    GiveFeedback,
    PrivacyConsent,
    CreateRoute,
    PlaceSettings,
    RouteSettings,
    PlaceImporter,
    ShareRoute,
    AssignDriver,
    Message,
    SignIn,
    PayWall
  },
  setup() {    
    const modals = store.modal.get(state => state.modals)

    return { modals }
  }
})
</script>

<style lang="scss">

</style>